/* eslint-disable */
export default [
    {
        name: 'YouTube',
        regex: /(youtube|youtu.be)/i,
        id: 'YouTube Video',
    },
    {
        name: 'Google Maps',
        regex: /(maps\/embed|maps\\embed)/i,
        id: 'Google Maps',
    },
];
